module.exports = __webpack_public_path__ + "static/media/no_beneficiary.81bbd902.svg";